function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#8a8c8c;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1374.25 -362.25)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M4.5,9h15",
  transform: "translate(1370.5 357.654)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M18.517,6.678l0,12.522A1.7,1.7,0,0,1,16.941,21H9.074A1.7,1.7,0,0,1,7.5,19.2l0-12.522M9.86,6.6V4.8A1.7,1.7,0,0,1,11.434,3h3.147a1.7,1.7,0,0,1,1.574,1.8V6.6",
  transform: "translate(1369.496 360)"
}));

var SvgCartDelete = function SvgCartDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.5,
    height: 19.5,
    viewBox: "0 0 16.5 19.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCartDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart-delete.86d1b528.svg";
export { ForwardRef as ReactComponent };